// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BcrA","left":"styles_left__HaQDS"};